import { useEffect } from 'react'
import { useLocation } from 'wouter'

export const RedirectToCreateOrg: React.FC = () => {
  const [, navigate] = useLocation()

  useEffect(() => {
    navigate(`/create-organization`)
  }, [navigate])

  return null
}
